import { cn } from "../lib/cn";

export function KMark({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 81.59 112.61"
      fill="currentColor"
      className={cn("h-full w-auto", className)}
      aria-label="Koloc"
    >
      <path d="M46.61,28.69c10.19-8.9,20.39-18.09,30.59-27.58l1.08,30.17c0,1.44-.07,2.87-.22,4.3-.14,1.3-.36,2.6-.64,3.88-.24,1.18-.76,2.29-1.51,3.23-2.3,3.16-6.11,5.24-11.42,6.25-.29,0-1.97,.4-5.06,1.19-3.1,.79-6.68,1.69-10.78,2.69s-8.37,2.08-12.82,3.23-8.26,2.08-11.41,2.8l33.82,.86c6.75,.29,11.77,1.98,15.08,5.07,3.36,3.18,5.65,7.32,6.57,11.85,1.13,5.42,1.46,10.97,1,16.48-.43,6.17-.93,12.5-1.51,19H44c1.05-4.08,1.84-8.21,2.37-12.39,.41-3.22,.59-6.46,.54-9.7-.04-2.47-.37-4.93-1-7.32-.47-1.83-1.11-3.61-1.91-5.32-1.38-3.22-3.81-5.88-6.89-7.54-.96-.4-1.97-.69-3-.86-1.44-.29-2.94-.57-4.52-.86s-3.2-.54-4.85-.76c-1.39-.19-2.79-.3-4.2-.32,1,1.29,2.58,3.63,4.74,7,2.34,3.7,4.46,7.54,6.35,11.49,2.08,4.31,3.71,8.82,4.85,13.46,1.14,4.25,1.21,8.71,.22,13H.72L.5,1.33c4.74,0,9.34-.07,13.79-.22h20.71c3.1-.11,6.06,1.25,8,3.67,1.87,2.15,2.49,4.23,1.84,6.24-.85,2.32-2.22,4.42-4,6.14-2.31,2.37-4.76,4.6-7.33,6.68-2.92,2.43-5.62,5.1-8.07,8-2.54,2.99-4.65,6.33-6.25,9.91-1.72,3.96-2.44,8.28-2.1,12.58,9.48-8.19,19.32-16.73,29.52-25.64Z" />
    </svg>
  );
}
